export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              name: "Contador",
              attributes: { class:'counter-container'},
              components: [
                {
                  tagName:'img', 
                  type:'image', 
                  attributes:{class:'icon-counter'},
                }, 
                {
                  tagName: 'div',
                  attributes: { class: 'counters' },
                  components: [
                    {
                      type:'counters',
                      attributes:{class:'counter-value font-40'},
                    },
                    {
                      type: 'text',
                      content: '+',
                      attributes: { class: 'sufix font-40'},
                    },
                  ],
                },
                   {
                  type: 'text',
                  content: 'Lorem',
                  attributes: { class: 'context font-20 light-gray' }
                },
              ],
              styles: `
              .icon-counter{
                width:36px;
                margin-bottom:20px;
              }
              .context{
                margin-top:15px;
              }
              .sufix{
                color:#363940; 
                margin-left:8px; 
              }
              .counters{
                display:flex;
                justify-content:center; 
                aling-items:center;
              }
              .font-40{
                font-size:40px;
              }
              .font-20{
                font-size:20px; 
              }
              .light-gray{
                color:#95A1BB;
              }
              .counter-container{
                display:flex;
                flex-direction:column; 
                align-items:flex-start; 
              }
              @media (max-width:992px){
                .counter-container{
                  align-items:center;
                }
              }
           `,
            },
          },
          view: {
      
          },
};
  return component; 
};